module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('shared-marketplace-provide-report-product', {
    attrs: {
      "product": _vm.product,
      "image": _vm.getImage()
    }
  }, [(_vm.attributes.length) ? _c('div', {
    staticClass: "l-col-12@md"
  }, _vm._l((_vm.attributes), function(attribute) {
    return _c('span', {
      staticClass: "ds-block"
    }, [_c('strong', [_vm._v(_vm._s(attribute.name) + ":")]), _vm._v(" " + _vm._s(attribute.value))])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1db36188","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/cnova/provide/report/Product.vue
// module id = 2960
// module chunks = 0